import React from "react";
import Slider from "react-slick";

const TestimonialSection = () => {

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } }
    ]
  };

  const testimonials = [
    {
      name: "Mr. Rahul Sharma",
      role: "Software Engineer",
      // image: "/images/testimonial/pic1.jpg",
      text: "Excellent cab service with polite drivers and clean cars. My ride was smooth, safe, and always on time."
    },
    {
      name: "Miss Priya Verma",
      role: "Doctor",
      // image: "/images/testimonial/default.jpg",
      text: "Very reliable service with affordable pricing and quick booking. I always choose Velocity Cab for my travel needs."
    },
    {
      name: "Mr. Amit Patel",
      role: "Businessman",
      // image: "/images/testimonial/pic3.jpg",
      text: "Great experience with professional drivers and comfortable vehicles. The journey was safe, easy, and completely hassle-free."
    },
    {
      name: "Miss Sneha Gupta",
      role: "Teacher",
      // image: "/images/testimonial/default.jpg",
      text: "Fast pickup service with friendly drivers and clean cars. I highly recommend Velocity Cab for daily and outstation rides."
    },
    {
      name: "Mr. Vikas Yadav",
      role: "Civil Engineer",
      // image: "/images/testimonial/pic2.jpg",
      text: "Affordable fares with excellent service quality. Booking was simple and the ride was comfortable and perfectly timed."
    },
    {
      name: "Miss Anjali Singh",
      role: "Student",
      // image: "/images/testimonial/default.jpg",
      text: "Safe and dependable cab service with great support. I always feel comfortable and secure during every ride."
    }
  ];

  return (
    <div className="section-full py-4 site-bg-dark twm-testimonial-section-wrap">
      <div className="container">

        {/* Title */}
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="section-head left">
              <div className="twm-sm-title left">Testimonials</div>
              <h2 className="twm-large-title site-text-white text-white">
                What Our Customers Say
              </h2>
            </div>
          </div>
        </div>

        <div className="section-content">

          <Slider {...settings} className="twm-blog-carousel next-prev-top-right">

            {testimonials.map((item, index) => (
              <div className="item" key={index}>

                <div className="twm-testimonial2 drk-view">

                  <div className="twm-testimonial-head">

                    <div className="media-pic">
                      <img
                        src={item.image}
                        alt="testimonial"
                        onError={(e) => {
                          e.target.src = "/images/testimonial/default.jpg";
                        }}
                      />
                    </div>

                    <div className="twm-author-detail">
                      <h3 className="twm-title">{item.name}</h3>
                      <div className="twm-position">
                        {item.role || "Customer"}
                      </div>
                    </div>

                  </div>

                  <div className="twm-testimonial-detail">

                    <p>{item.text}</p>

                    <div className="twm-rating-wrap">
                      {[...Array(5)].map((_, i) => (
                        <span key={i}>
                          <i className="fa fa-star"></i>
                        </span>
                      ))}
                    </div>

                  </div>

                  <div className="twm-quote-icon">
                    <img src="/images/quote.png" alt="quote" />
                  </div>

                </div>

              </div>
            ))}

          </Slider>

        </div>

      </div>
    </div>
  );
};

export default TestimonialSection;